module.exports = __webpack_public_path__ + "bb67a6d56f872c7268c6435fc8945ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Heart.png
// module id = 778
// module chunks = 0